// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bundleBadge":"_0iKVZ","grid":"XxJi1","list":"Zi3cI","btmLft":"YXd-R","topLft":"_2Ls2M","text":"Oshhw","circle":"X-1VM"};